function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScCross = function SvgScCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--on-surface)",
    strokeWidth: 2,
    d: "m6 6 12 12m0-12L6 18",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    vectorEffect: "non-scaling-stroke"
  }));
};
export default SvgScCross;